import React from 'react';

import { SvgComplexIcon, SvgIconProps } from './SvgIcon';

const ExploreIcon = (props: SvgIconProps) => (
  <SvgComplexIcon
    {...props}
    viewBox={[60, 60, 520, 520]}
    d="M191.3 68.5C202 60.7 217 63 224.8 73.7C232.6 84.4 230.3 99.4 219.7 107.3C154.3 155.3 112 232.7 112 320C112 434.9 205.1 528 320 528C434.9 528 528 434.9 528 320C528 236.1 459.9 168 376 168C292.1 168 224 236.1 224 320C224 373 267 416 320 416C373 416 416 373 416 320C416 297.9 398.1 280 376 280C353.9 280 336 297.9 336 320C336 333.3 325.3 344 312 344C298.7 344 288 333.3 288 320C288 271.4 327.4 232 376 232C424.6 232 464 271.4 464 320C464 399.5 399.5 464 320 464C240.5 464 176 399.5 176 320C176 209.5 265.5 120 376 120C486.5 120 576 209.5 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320C64 216.8 114.1 125.3 191.3 68.5z"
  />
);

export default ExploreIcon;
